// src/hooks/useNewbieData.js
/**
 * useNewbieData
 * --------------------------------------------------------------------
 * 목적:
 *  - 신규 가입자 페이지 전반에서 공통으로 쓰는 상태를 스토어에서 구독하고,
 *    기준 날짜(date) 변경 시 신규 가입자 데이터를 자동으로 재요청.
 *
 * 동작 요약:
 *  - Redux store의 newbie 슬라이스를 useSelector로 구독.
 *  - date가 바뀌면 fetchNewbie(date || 오늘)를 디스패치.
 *  - 화면에서 쓰기 좋은 키명으로 매핑하여 반환.
 *
 * 반환:
 *  {
 *    currentDate,      // 기준 날짜(문자열)
 *    storeId,          // 매장 식별자
 *    visitDetailValue, // { daily, weekly, monthly }
 *    validDateList,    // 선택 가능한 날짜 목록(달력에 사용)
 *    isLoadingState,   // 로딩 플래그
 *    error,            // 에러 정보
 *  }
 *
 */

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchNewbie } from "../store/slices/newbieSlice";
import { formatDate } from "../functions/DateConverter";

export default function useNewbieData() {
  const dispatch = useDispatch();

  // newbie 슬라이스에서 필요한 필드 선택
  const { date, storeId, visitDetail, validDateList, isLoading, error } =
    useSelector((state) => state.newbie);

  useEffect(() => {
    // 기준 날짜가 있으면 그것으로, 없으면 오늘 날짜로 조회
    dispatch(fetchNewbie(date || formatDate(new Date())));
  }, [dispatch, date]);

  // 뷰에서 쓰기 좋은 이름으로 반환(다른 훅/컴포넌트와 네이밍 통일)
  return {
    currentDate: date,
    storeId,
    visitDetailValue: visitDetail,
    validDateList,
    isLoadingState: isLoading,
    error,
  };
}
